import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { from, Observable } from 'rxjs';

import * as contentful from 'contentful/dist/contentful.browser.min.js';
import { Mentor } from '../../components/sections/faq/mentor';
import { Webinar } from '../../components/sections/webinars/webinar';
import { Blog } from '../../components/sections/blog/blog';

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {

  private contentfulClient = contentful.createClient({
    space: environment.contentfulConfig.space,
    accessToken: environment.contentfulConfig.accessToken
  });

  constructor() {
  }

  getBlogs(query?: any): Observable<any> {
    return from(
      this.contentfulClient.getEntries<Blog[]>({
        content_type: environment.contentfulConfig.contentTypes.blogs,
        order: 'sys.createdAt'
      })
        .then((entries) => {
          return entries.items;
        })
    );
  }

  getWebinars(query?: any): Observable<any> {
    return from(
      this.contentfulClient.getEntries<Webinar[]>({
        content_type: environment.contentfulConfig.contentTypes.webinars,
        order: 'sys.createdAt'
      })
        .then((entries) => {
          return entries.items;
        })
    );
  }

  getMentors(query?: any): Observable<any> {
    return from(
      this.contentfulClient.getEntries<Mentor[]>({
        content_type: environment.contentfulConfig.contentTypes.mentors,
      })
        .then((entries) => {
          return entries.items;
        })
    );
  }
}
